// extracted by mini-css-extract-plugin
module.exports = {"container":"popup_container__37YJ2","wrapper":"popup_wrapper__S9lyQ"};